import { gql } from '@apollo/client';

export const HOST = gql`
  query mapHostData($id: Int!) {
    hostOverview(id: $id) {
      id
      alias
      type
      position
      group_id
      shell_mode
      online
      in_service
      device_has_changed
      online_booking_enabled
      locked
      mac_addr
      ip_addr

      info {
        shell_version
      }

      bookings {
        id
        from
        to
        hosts
      }

      user {
        uuid
        nickname
        phone

        roles {
          alias
        }
      }

      client_sessions {
        id
        started_at
        finished_at
        time_left

        seances {
          id
          status

          tariff {
            title
          }
        }
      }
    }
  }
`;

export const GET_HOST = gql`
  query mapHostData($id: Int!) {
    hostOverview(id: $id) {
      id
      group_id
      position
      alias
      coord_x
      coord_y
      in_service
      online
      shell_mode
      device_has_changed
      locked
      mac_addr
      ip_addr
      online_booking_enabled
      type
      user {
        nickname
        uuid
        phone
        deposit
        user_discount

        roles {
          alias
        }
      }

      info {
        shell_version
      }

      bookings {
        id
        from
        to
        hosts
        byClient

        client {
          uuid
          nickname
        }
      }

      counters {
        active_window
      }

      client_sessions {
        id
        started_at
        finished_at
        duration
        elapsed
        time_left
        postpaid

        seances {
          id
          status

          tariff {
            id
            title
            kind
          }
        }
      }
    }
  }
`;

export const HOST_GROUP = gql`
  query draggableHostGroupData($id: Int!) {
    hostGroupOverview(id: $id) {
      title
      priority
      customization {
        color
      }
    }
  }
`;
